import {PropertyRpId} from "../../../types/ids";
import {IFavoriteListItemDTO} from "../../favorites/list/types/IFavoriteListItemDTO";
import {isExternalFavorite} from "../../favorites/list/utils/is_external_favorite";
import {View} from "../../km_app/types/View";
import {getAmplitudeExternalFavoriteListProduct} from "./get_amplitude_external_favorite_properties";
import {getAmplitudeViewItemListProducts} from "./get_amplitude_view_item_list_products";

interface IGetAmplitudeFavoriteListProductParams {
    favorite: IFavoriteListItemDTO;
    index: number;
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

interface IGetAmplitudeFavoriteListProductsParams {
    favorites: IFavoriteListItemDTO[];
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

const getAmplitudeFavoriteListProduct = (params: IGetAmplitudeFavoriteListProductParams) => {
    const {favorite, index, sentPropertyRpIds, viewType} = params;

    if (favorite.property) {
        const [product] = getAmplitudeViewItemListProducts({
            properties: [favorite.property],
            sentPropertyRpIds,
            viewType
        });

        return product ? [{...product, index}] : [];
    }

    if (isExternalFavorite(favorite)) return [getAmplitudeExternalFavoriteListProduct(favorite, index)];

    return [];
};

export const getAmplitudeFavoriteListProducts = (params: IGetAmplitudeFavoriteListProductsParams) => {
    const {favorites, sentPropertyRpIds, viewType} = params;

    return favorites.flatMap((favorite, index) => getAmplitudeFavoriteListProduct({favorite, index, sentPropertyRpIds, viewType}));
};
import {PropertyRpId} from "../../../types/ids";
import {IFavoriteListItemDTO} from "../../favorites/list/types/IFavoriteListItemDTO";
import {isExternalFavorite} from "../../favorites/list/utils/is_external_favorite";
import {View} from "../../km_app/types/View";
import {getAmplitudeExternalFavoriteListProduct} from "./get_amplitude_external_favorite_properties";
import {getAmplitudeViewItemListProducts} from "./get_amplitude_view_item_list_products";

interface IGetAmplitudeFavoriteListProductParams {
    favorite: IFavoriteListItemDTO;
    index: number;
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

interface IGetAmplitudeFavoriteListProductsParams {
    favorites: IFavoriteListItemDTO[];
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

const getAmplitudeFavoriteListProduct = (params: IGetAmplitudeFavoriteListProductParams) => {
    const {favorite, index, sentPropertyRpIds, viewType} = params;

    if (favorite.property) {
        const [product] = getAmplitudeViewItemListProducts({
            properties: [favorite.property],
            sentPropertyRpIds,
            viewType
        });

        return product ? [{...product, index}] : [];
    }

    if (isExternalFavorite(favorite)) return [getAmplitudeExternalFavoriteListProduct(favorite, index)];

    return [];
};

export const getAmplitudeFavoriteListProducts = (params: IGetAmplitudeFavoriteListProductsParams) => {
    const {favorites, sentPropertyRpIds, viewType} = params;

    return favorites.flatMap((favorite, index) => getAmplitudeFavoriteListProduct({favorite, index, sentPropertyRpIds, viewType}));
};
